import CoreUtils from '../../common/utils/CoreUtils';
import DateTimeUtils from '../../common/utils/DateTimeUtils';

export default class CorePropertyHelper {
  static createElectionCutoff(utcElectionCutoff) {
    return {
      utcElectionCutoffMs: DateTimeUtils.parseDtoDateTime(utcElectionCutoff),
      isPastElectionCutoff: false,
      showElectionCutoffAlert: false
    };
  }

  static processElectionCutoff(electionCutoff, serverUtcTimeMs, warningPeriodMs, cutoffStatusFlags) {
    var isPastElectionCutoff = false;
    var showElectionCutoffAlert = false;
    var utcElectionCutoffMs = electionCutoff.utcElectionCutoffMs;

    if (CoreUtils.isDefinedAndNotNull(utcElectionCutoffMs)) {
      isPastElectionCutoff = utcElectionCutoffMs <= serverUtcTimeMs;

      showElectionCutoffAlert = !isPastElectionCutoff
        && warningPeriodMs > 0
        && utcElectionCutoffMs <= serverUtcTimeMs + warningPeriodMs;
    }

    if (isPastElectionCutoff !== electionCutoff.isPastElectionCutoff) {
      electionCutoff.isPastElectionCutoff = isPastElectionCutoff;
      cutoffStatusFlags.revertModifiedValues = true;
      cutoffStatusFlags.cutOffStatusChanged = true;
    }

    if (showElectionCutoffAlert !== electionCutoff.showElectionCutoffAlert) {
      electionCutoff.showElectionCutoffAlert = showElectionCutoffAlert;
      cutoffStatusFlags.cutOffStatusChanged = true;
    }
  }
}